import axiosClient from './axiosClient';

export interface EmailProcessingActivity {
  id: number;
  subject: string | null;
  status: 'PROCESSING' | 'COMPLETED' | 'FAILED';
  attempts: number;
  errorMessage: string | null;
  createdAt: string;
  completedAt: string | null;
  readAt: string | null;
  processedRecords: number | null;
  failedRecords: number | null;
  summary: Record<
    string,
    Array<{
      status: string;
      row?: { type?: string; symbol?: string; quantity?: number | string };
    }>
  > | null;
}

export async function getEmailProcessingActivity(): Promise<
  EmailProcessingActivity[]
> {
  const { data } = await axiosClient.get<EmailProcessingActivity[]>(
    '/csv/email-sync/activity'
  );
  return data;
}

export async function setEmailActivityRead(
  id: number,
  read: boolean
): Promise<void> {
  await axiosClient.patch(`/csv/email-sync/activity/${id}/read`, { read });
}

export async function dismissEmailActivity(id: number): Promise<void> {
  await axiosClient.delete(`/csv/email-sync/activity/${id}`);
}

export async function setAllEmailActivityRead(read: boolean): Promise<void> {
  await axiosClient.patch(
    `/csv/email-sync/activity/${read ? 'read-all' : 'unread-all'}`
  );
}

export async function dismissAllEmailActivity(): Promise<void> {
  await axiosClient.delete('/csv/email-sync/activity');
}

export async function retryEmailActivity(id: number): Promise<void> {
  await axiosClient.post(`/csv/email-sync/activity/${id}/retry`);
}
